// Runtime config from window (set by public/config.js loaded at startup)
const runtimeConfig = window.__RUNTIME_CONFIG__ || {};

// Helper to check if a value is an unresolved placeholder (used in production containers).
// Only checks for the literal marker — "" is a real, intentional value, not a placeholder.
const isPlaceholder = (value) => {
    return typeof value !== 'string' || value.includes('PLACEHOLDER');
};

// Use runtime config only if it's not a placeholder, otherwise fall back to env vars.
// Uses `!== undefined` (not `||`) so an intentionally blank "" is preserved instead of
// being overwritten by defaultValue.
const getValue = (runtimeValue, envValue, defaultValue) => {
    if (!isPlaceholder(runtimeValue)) {
        return runtimeValue;
    }
    return envValue !== undefined ? envValue : defaultValue;
};

const config = {
    serviceUrl: getValue(
        runtimeConfig.serviceUrl,
        process.env.REACT_APP_SERVICE_URL,
        "http://localhost:9380/api/v1"
    ),
    baseMediaUrl: getValue(
        runtimeConfig.baseMediaUrl,
        process.env.REACT_APP_BASE_MEDIA_URL,
        "http://discover-media.elastiq.ai/"
    ),
    canvasApiUrl: getValue(
        runtimeConfig.canvasApiUrl,
        process.env.REACT_APP_CANVAS_API_URL,
        "http://localhost:9380/v1/canvas/canvas_info"
    ),
    apiKey: getValue(
        runtimeConfig.apiKey,
        process.env.REACT_APP_API_KEY,
        "discover-ExZjY5NDE2MDBlNjExZjE5NGE4ZWViNz"
    ),

    env: getValue(
        runtimeConfig.env,
        process.env.REACT_APP_ENV,
        "dev"
    ),

    // White-label branding
    brandName: getValue(
        runtimeConfig.brandName,
        process.env.REACT_APP_BRAND_NAME,
        "discover"
    ),
    brandTagline: getValue(
        runtimeConfig.brandTagline,
        process.env.REACT_APP_BRAND_TAGLINE,
        "by elastiq.ai"
    ),
    brandShortName: getValue(
        runtimeConfig.brandShortName,
        process.env.REACT_APP_BRAND_SHORT_NAME,
        "elastiq.ai"
    ),
    brandFullName: getValue(
        runtimeConfig.brandFullName,
        process.env.REACT_APP_BRAND_FULL_NAME,
        "Elastiq Discover"
    ),
    brandLogoUrl: getValue(
        runtimeConfig.brandLogoUrl,
        process.env.REACT_APP_BRAND_LOGO_URL,
        "/discoverLogo.png"
    ),
    // Multiplier on top of each spot's base logo height — tune per client when
    // a logo file has more internal padding than discover's and renders small.
    brandLogoScale: parseFloat(getValue(
        runtimeConfig.brandLogoScale,
        process.env.REACT_APP_BRAND_LOGO_SCALE,
        "1"
    )) || 1,

    // Keycloak SSO Configuration
    keycloak: {
        serverUrl: getValue(
            runtimeConfig.keycloakServerUrl,
            process.env.REACT_APP_KC_SERVER_URL,
            "https://auth.elastiq.app"
        ),
        realm: getValue(
            runtimeConfig.keycloakRealm,
            process.env.REACT_APP_KC_REALM,
            "discover_chat"
        ),
        clientId: getValue(
            runtimeConfig.keycloakClientId,
            process.env.REACT_APP_KC_CLIENT_ID,
            "discover-chat-app"
        ),
    }
};

export default config;
